// extracted by mini-css-extract-plugin
export default {"container":"BMyw_o","croutonWrapper":"yr2Qjz"};